import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import {
  ChangePassword,
  Notification,
  NotificationDetails,
  PersonaInformation,
  Products,
  Services,
  UsersList,
  UserSettings,
} from "@/pages";
import React from "react";
import { permissionsAllowToAll } from "@/utils/permissions/permissionsAllowToAll";
import { permissionsCompaniesReadonly } from "@/utils/permissions/permissionsCompaniesReadonly";
import { checkoutRoutes } from "./checkoutRoutes";
import { permissionsSettings } from "@/utils";

const parentPath = "user-account";

/**
 * Route definitions for user account management routes.
 * Allows users to manage their profile, notifications, password, and customers.
 */
export const userAccountRoutes: React.ReactElement<any>[] = [
  <Route
    key="settings"
    path="settings"
    element={
      <ProtectedRoute element={<UserSettings />} codes={permissionsSettings} />
    }
  />,
  <Route
    key="notifications"
    path="notifications"
    element={
      <ProtectedRoute
        element={<Notification />}
        codes={permissionsAllowToAll}
      />
    }
  />,
  <Route
    key="notification-details"
    path="notifications/:notificationId"
    element={
      <ProtectedRoute
        element={<NotificationDetails />}
        codes={permissionsAllowToAll}
      />
    }
  />,
  <Route
    key="profile"
    path="profile"
    element={
      <ProtectedRoute
        element={<PersonaInformation />}
        codes={permissionsAllowToAll}
      />
    }
  />,
  <Route
    key="products"
    path="products"
    element={
      <ProtectedRoute element={<Products />} codes={permissionsAllowToAll} />
    }
  />,
  <Route
    key="change-password"
    path="change-password"
    element={
      <ProtectedRoute
        element={
          (
            <ChangePassword parentPath={parentPath} />
          ) as React.ReactElement<any>
        }
        codes={permissionsAllowToAll}
      />
    }
  />,

  <Route
    key="customers"
    path="customers"
    element={
      <ProtectedRoute
        element={
          (
            <UsersList userFilter="tenant" parentPath={parentPath} />
          ) as React.ReactElement<any>
        }
        codes={permissionsCompaniesReadonly}
      />
    }
  />,

  <Route
    key="services"
    path="services"
    element={
      <ProtectedRoute element={<Services />} codes={permissionsAllowToAll} />
    }
  />,
  <Route path="checkout">{checkoutRoutes}</Route>,
];
